(function () {

    function playActiveVideo(splide) {
        splide.root.querySelectorAll('video').forEach(video => {
            const isActive = video.closest('.splide__slide').classList.contains('is-active');

            if (isActive && video.paused && video.dataset.userPaused !== 'true') {
                video.play().catch(() => { });
            } else if (!isActive && !video.paused) {
                video.pause();
            }
        });
    }

    function setupClickToCenter(splide) {
        splide.Components.Slides.forEach((slideComponent) => {
            const slide = slideComponent.slide;
            const card = slide.querySelector('.influencers-video-card');
            const video = slide.querySelector('video');

            card.style.cursor = 'pointer';

            if (video) {
                video.addEventListener('click', () => {
                    if (!slide.classList.contains('is-active')) {
                        splide.go(slideComponent.index);
                    }
                });
            }
        });
    }

     function setupPagination(splide) {
        const dots = splide.root.querySelectorAll('.custom-pagination');
        const totalSlides = splide.Components.Elements.slides.length;
        const slidesPerGroup = 5;

        dots.forEach((dot, index) => {
            dot.addEventListener('click', (e) => {
                splide.go(parseInt(dot.dataset.slide));
            })
        });

       splide.on('active', (slide) => {
        const active = Math.ceil(splide.index / slidesPerGroup)
        dots.forEach( dot => dot.classList.remove('active'))
        dots[active].classList.add('active');
       });
    }

    const carousel = document.querySelector('.influencers-videos-carousel');

    if (carousel && carousel.splide) {
        const splide = carousel.splide;

        setupClickToCenter(splide);
        setupPagination(splide);
        splide.on('active', () => playActiveVideo(splide));
        playActiveVideo(splide);
    }
})();